var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-2 mb-4 font-sans-bold"},[_vm._v("Collaborator Agreement")]),_vm._v(" "),_c('div',{staticClass:"w-full my-3 overflow-y-scroll mb-12 contract-text",domProps:{"innerHTML":_vm._s(_vm.contractLegal)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }